import { PublicClientApplication } from "@azure/msal-browser";
import { msalConfig, loginRequest } from "./authConfig";

const msalInstance = new PublicClientApplication(msalConfig);
msalInstance.enableAccountStorageEvents();

export default msalInstance;

export async function getApiToken() {
    const account = msalInstance.getActiveAccount() ?? msalInstance.getAllAccounts()[0];
    const response = await msalInstance.acquireTokenSilent({ ...loginRequest, account });
    return response.accessToken;
}